import 'url-search-params-polyfill';
import { sportTypeIds } from '../utils/eventConstants';
import { search } from './searchApi';

// for simulating server latency
// eslint-disable-next-line no-unused-vars
const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

const saveRegistration = (axiosInstance, registrationValues) => {
    if (registrationValues.id) {
        return axiosInstance.put(
            `v1/myutrsurvey/respondent/${registrationValues.id}`,
            registrationValues,
        );
    }
    return axiosInstance.post(
        'v1/myutrsurvey/respondent',
        registrationValues,
    );
};

const saveSurvey = (axiosInstance, surveyValues) => {
    if (surveyValues.id) {
        return axiosInstance.put(
            `v1/myutrsurvey/survey/${surveyValues.id}`,
            surveyValues,
        );
    }
    return axiosInstance.post(
        'v1/myutrsurvey/survey',
        surveyValues,
    );
};

const calculateRating = (axiosInstance, surveyValues) => {
    return axiosInstance.post(
        'v1/myutrsurvey/rating',
        surveyValues,
    );
};

const selectMyUtr = (axiosInstance, myUtr) => {
    return axiosInstance.post(`v1/myutrsurvey/ratingselect`, { myUtr });
};

const confirmRating = (axiosInstance, confirmValues) => {
    return axiosInstance.put(
        `v1/myutrsurvey/ratingconfirm/${confirmValues.playerId}`,
        confirmValues,
    );
};

const getProfileMaches = (axiosInstance, userParams) => {
    return axiosInstance.get('v1/player/profilematch', {
        params: userParams,
    });
};

const registerAccount = (axiosInstance, accountParams) => {
    return axiosInstance.post('v1/account/register', {
        ...accountParams,
    });
};

const updateAccount = (axiosInstance, accountParams) => {
    return axiosInstance.post('v1/account/update', {
        ...accountParams,
    });
};

const updateMissingInfo = (axiosInstance, accountParams) => {
    return axiosInstance.post('v1/account/updatebasic', {
        ...accountParams,
    });
};

const submitContact = (axiosInstance, contactParams) => {
    return axiosInstance.post('v1/myutrsurvey/contact', contactParams);
};

const searchAggregations = (axiosInstance, dataType, aggregations) => {
    const url = `v2/search/${dataType}/aggregations`;
    return axiosInstance.post(url, aggregations);
};

const playerMeta = (axiosInstance, playerId) => {
    const url = `v1/player/${playerId}/meta`;

    return axiosInstance.get(url);
};

const playerProfile = (axiosInstance, playerId) => {
    const url = `v1/player/${playerId}/profile`;

    return axiosInstance.get(url);
};

const availableRegions = (axiosInstance, stateAbbr, countryCode) => {
    const url = `v1/Countries/${countryCode}/states/${stateAbbr}/regions`;

    return axiosInstance.get(url);
};

const playerStudentInfo = (axiosInstance, playerId) => {
    console.log('playerStudentInfo api', playerId);
    const url = `/v1/player/${playerId}/studentInfo`;

    return axiosInstance.get(url);
};

const savePlayerStudentInfo = (axiosInstance, values) => {
    const url = `/v1/player/studentInfo`;

    return axiosInstance.put(url, values);
};

export const playerStats = (axiosInstance, playerId, params) => {
    const url = `v4/player/${playerId}/all-stats`;
    const newParams = {
        type: params.type || 'singles',
        resultType: params.resultType || 'verified',
        months: params.months || 6,
        fetchAllResults: params.fetchAllResults || false,
    };
    return axiosInstance.get(url, {
        params: newParams,
    });
};

const saveProfile = (axiosInstance, playerId, values) => {
    const url = `v1/player/${playerId}/profile`;
    return axiosInstance.post(url, values);
};

const fetchMatch = (axiosInstance, player1Id, player2Id) => {
    const url = `v1/player/featuredmatch?player1Id=${player1Id}&player2Id=${player2Id}`;
    return axiosInstance.get(url);
};

export const sendMessage = (axiosInstance, message, eventId, drawId, sendCopyToOrganizer, memberIds) => {
    const url = `v1/tms/events/${eventId}/sendemailnotification`;
    const body = {
        message,
        drawId,
        sendCopyToOrganizer,
    };
    if (memberIds) {
        body.memberIds = memberIds;
    }
    return axiosInstance.post(url, body);
};

const getPostableMatchups = (axiosInstance, memberId, skip, top) => {
    const params = {
        top,
        skip,
    };
    const url = `v1/score/member/${memberId}/matchups`;
    return axiosInstance.get(url, {
        params,
    });
};

const getPostableMatch = (axiosInstance, memberId, matchId) => {
    const url = `v1/score/member/${memberId}/matchups/${matchId}`;
    return axiosInstance.get(url);
};

const postScore = (axiosInstance, result) => {
    return axiosInstance.post('v1/score/submit', result);
};

const clearScore = (axiosInstance, match) => {
    return axiosInstance.post('v1/score/clear', match);
};

const deleteScore = (axiosInstance, resultId, result) => {
    const isSinglePointResult = result?.sportTypeId === sportTypeIds.PICKLEBALL;

    if (isSinglePointResult) {
        return axiosInstance.delete(`v1/score/singlepoint/${resultId}`);
    }

    return axiosInstance.delete(`v1/score/${resultId}`);
};

const acceptOrRejectResult = (axiosInstance, resultId, acceptOrreject, result) => {
    const isSinglePointResult = result?.sportTypeId === sportTypeIds.PICKLEBALL;

    if (isSinglePointResult) {
        return axiosInstance.post(`v1/score/singlepoint/${resultId}/${acceptOrreject}`);
    }
    return axiosInstance.post(`v1/score/${resultId}/${acceptOrreject}`);
};

export const resendPostScoreInvite = (axiosInstance, resultId) => {
    const url = `v1/score/${resultId}/resendinvites`;
    return axiosInstance.post(url);
};

export const postSinglePointScore = (axiosInstance, result) => {
    return axiosInstance.post('v1/score/SinglePoint/submit', result);
};

export const clearSinglePointScore = (axiosInstance, match) => {
    return axiosInstance.post('v1/score/SinglePoint/clear', { matchId: match.matchId });
};

export const deleteSinglePointScore = (axiosInstance, resultId) => {
    const url = `v1/score/SinglePoint/${resultId}`;
    return axiosInstance.delete(url);
};

export const acceptOrRejectSinglePointResult = (axiosInstance, resultId, acceptOrreject) => {
    return axiosInstance.post(`v1/score/SinglePoint/${resultId}/${acceptOrreject}`);
};

export const resendSinglePointPostScoreInvite = (axiosInstance, resultId) => {
    const url = `v1/score/SinglePoint/${resultId}/resendinvites`;
    return axiosInstance.post(url);
};

const invitePlayers = (axiosInstance, result) => {
    return axiosInstance.post('v1/score/inviteplayers', result);
};

const validateInviteToken = (axiosInstance, values) => {
    return axiosInstance.post('v1/auth/invite', values);
};

const declineInviteToken = (axiosInstance, values) => {
    return axiosInstance.post('v1/auth/invite/decline', values);
};

const validateReferralCode = (axiosInstance, values) => {
    return axiosInstance.post('v1/auth/referral', values);
};

const getMemberDashBoard = (axiosInstance) => {
    const url = `v1/member/dashboard?optimized=true`;
    return axiosInstance.get(url);
};

const getMemberDashBoardNew = (axiosInstance) => {
    const url = `v1/member/dashboard/mystuff?optimized=true`;
    return axiosInstance.get(url);
};

const getMemberDashBoardNotification = (axiosInstance) => {
    const url = `v1/member/dashboard/notification`;
    return axiosInstance.get(url);
};

const getMemberDashBoardResults = (axiosInstance) => {
    const url = `v2/member/dashboard/myresults`;
    return axiosInstance.get(url);
};

const getMemberPendingResults = (axiosInstance) => {
    const url = `v1/member/dashboard/mypendingresults`;
    return axiosInstance.get(url);
};

const getFlexLeagueMatchCards = (axiosInstance) => {
    const url = `v1/member/dashboard/fleaxleagues/matches`;
    return axiosInstance.get(url);
};

export const disableActionCard = (axiosInstance, cardId) => {
    const url = `v1/member/updateactioncard`;
    const postParams = {
        id: cardId,
        isEnabled: false,
    };
    return axiosInstance.post(url, postParams);
};

const getMemberDashBoardClubs = (axiosInstance) => {
    const url = `v1/member/dashboardClubs`;
    return axiosInstance.get(url);
};

const getTypes = (axiosInstance) => {
    const url = `v1/types/all`;
    return axiosInstance.get(url);
};

const getSearchTypes = (axiosInstance) => {
    const url = `v1/types/search`;
    return axiosInstance.get(url);
};

const getUtrRangeTypes = (axiosInstance) => {
    const url = `v1/types/utr-range`;
    return axiosInstance.get(url);
};
const getPickleballRatingTypes = (axiosInstance) => {
    const url = `v1/types/pickelball-rating`;
    return axiosInstance.get(url);
};

const addFreshchatRestoreId = (axiosInstance, restoreId) => {
    const url = `v1/account/freshchat`;
    return axiosInstance.post(url, { restoreId });
};

const validateEmailVerificationToken = (axiosInstance, values) => {
    return axiosInstance.post('v1/auth/secondaryemailverification', values);
};

const unsubscribeEmail = (axiosInstance, managementToken) => {
    const url = `v1/member/communication/${managementToken}`;
    return axiosInstance.delete(url);
};

const playerRankings = (axiosInstance, playerId) => {
    const url = `v2/player/${playerId}/rankings`;
    return axiosInstance.get(url);
};

const playerPtsRankings = (axiosInstance, playerId) => {
    const url = `v2/player/${playerId}/rankings/pts`;
    return axiosInstance.get(url);
};

const savePaymentMethod = (axiosInstance, values) => {
    const url = `/v2/memberpaymentmethods/attach-payment-method`;
    return axiosInstance.post(url, values);
};

const fetchPaymentMethods = (axiosInstance) => {
    const url = `/v2/memberpaymentmethods/get-payment-methods`;
    return axiosInstance.get(url);
};

const deletePaymentMethod = (axiosInstance, cardId) => {
    const url = `/v2/memberpaymentmethods/${cardId}`;
    return axiosInstance.delete(url);
};

const validateActivateUtrToken = (axiosInstance, values) => {
    return axiosInstance.post('v1/auth/validatetoken', values);
};

const connectPlayerThirdPartyId = (axiosInstance, values) => {
    return axiosInstance.post('v2/player/connect/thirdPartyId', values);
};

const getProfileLocalizedRankings = (axiosInstance, playerId) => {
    return axiosInstance.get(`/rankings/v1/player/${playerId}`);
};

const saveProfileView = (axiosInstance, playerId) => {
    return axiosInstance.post(`v1/playerprofileviews/${playerId}`);
};

const getProfileViews = (axiosInstance, playerId, page, pageSize, gender) => {
    const genderQuery = gender ? `&gender=${encodeURIComponent(gender)}` : '';
    return axiosInstance.get(`v1/playerprofileviews/${playerId}/collegecoach?pageSize=${pageSize}&page=${page}${genderQuery}`);
};

const submitScoreUpdateRequest = (axiosInstance, requestData) => {
    return axiosInstance.post('v1/Result/ScoreUpdateRequest', requestData);
};

const getBatchScoreUpdateRequestStatus = (axiosInstance, resultIds) => {
    return axiosInstance.post('v1/Result/ScoreUpdateRequestStatus/Batch', {
        resultIds,
    });
};

const submitMagicLink = (axiosInstance, requestData) => {
    return axiosInstance.post('/v1/auth/magic-link', requestData);
};

const verifyMagicLink = (axiosInstance, requestData) => {
    return axiosInstance.post('/v1/auth/magic-link/verify', requestData);
};

const getPlayerVolumetricStats = (axiosInstance, playerId, params) => {
    return axiosInstance.get(`/stats/volumetric/v1/Player/${playerId}`, { params });
};

const getProfileActivityOverview = (axiosInstance, playerId) => {
    return axiosInstance.get(`/stats/volumetric/v1/Player/${playerId}/overview`);
};

export {
    saveRegistration,
    calculateRating,
    confirmRating,
    selectMyUtr,
    saveSurvey,
    getProfileMaches,
    registerAccount,
    updateAccount,
    updateMissingInfo,
    submitContact,
    search,
    searchAggregations,
    playerMeta,
    playerProfile,
    saveProfile,
    fetchMatch,
    postScore,
    clearScore,
    invitePlayers,
    validateInviteToken,
    validateReferralCode,
    declineInviteToken,
    getTypes,
    getSearchTypes,
    getUtrRangeTypes,
    getPickleballRatingTypes,
    addFreshchatRestoreId,
    getMemberDashBoard,
    getMemberDashBoardClubs,
    getMemberDashBoardResults,
    getMemberPendingResults,
    getFlexLeagueMatchCards,
    getMemberDashBoardNew,
    getMemberDashBoardNotification,
    deleteScore,
    acceptOrRejectResult,
    playerStudentInfo,
    savePlayerStudentInfo,
    validateEmailVerificationToken,
    unsubscribeEmail,
    playerRankings,
    getPostableMatchups,
    getPostableMatch,
    playerPtsRankings,
    availableRegions,
    savePaymentMethod,
    fetchPaymentMethods,
    deletePaymentMethod,
    validateActivateUtrToken,
    connectPlayerThirdPartyId,
    getProfileLocalizedRankings,
    saveProfileView,
    getProfileViews,
    submitScoreUpdateRequest,
    getBatchScoreUpdateRequestStatus,
    submitMagicLink,
    verifyMagicLink,
    getPlayerVolumetricStats,
    getProfileActivityOverview,
};
